import styled from "styled-components/macro";

export const Container = styled.div(({ theme: { spacing } }) => ({
  "> *:not(:last-child)": {
    marginBottom: spacing.stack["2xs"],
  },
}));

export const Card = styled.div(({ theme: { color, spacing, breakpoint } }) => ({
  backgroundColor: color.neutral["08"],
  padding: `${spacing.inline.xs} ${spacing.inline.xs} ${spacing.inline["3xs"]}`,

  [breakpoint.lg()]: {
    padding: `${spacing.inline.md} ${spacing.inline.xs} ${spacing.inline["3xs"]}`,
  },
}));
